import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

import SubPageLayout from "reusables/layouts/SubPageLayout";

import Onboarding_Section1 from "./sections/Onboarding_Section1";

function PropertyOnboarding() {
  usePageMeta({
    title: "Property Assessment & Onboarding Ireland | Spechs",
    description:
      "Seamless property assessment and onboarding with Spechs. We get your property ready for professional management.",
    canonical: "https://www.spechs.ie/property/onboarding/",
  });

  return (
    <SubPageLayout title="Property Assessment & Onboarding">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Onboarding_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default PropertyOnboarding;
